import { NgModule } from '@angular/core';
import { UpgradedServicesModule } from '../upgraded-services/upgraded.services.module';
import { ImActivity } from './im-activity.service';
import { ImCachedObject } from './im-cached-object.service';
import { ImCourseDiff } from './im-course-diff';
import { ImFlag } from './im-flag';
import { ImGapPlan } from './im-gap-plan';
import { ImNote } from './im-note.service';
import { ImNotification } from './im-notification.service';
import { ImSchool } from './im-school';
import { ImStudentActivity } from './im-student-activity.service';
import { ImStudent } from './im-student.service';
import { ImUser } from './im-user';

@NgModule({
  imports: [UpgradedServicesModule],
  providers: [
    ImNote,
    ImUser,
    ImSchool,
    ImStudent,
    ImCachedObject,
    ImNotification,
    ImFlag,
    ImCourseDiff,
    ImGapPlan,
    ImActivity,
    ImStudentActivity,
  ],
})
export class ImModelsModule {}
